import { jsx as _jsx } from "react/jsx-runtime";
import localeTranslator from 'library/Hocs/LocalTranslator';
import MedicalMachines from './entities/MedicalMachines';
import Products from './entities/Products';
import AppointmentTypes from './entities/AppointmentTypes';
import OrderEntities from './entities/OrderEntities';
var PackageDetails = function (props) {
    switch (props.package.getEntityType()) {
        case 'MedicalMachine':
            return (_jsx(MedicalMachines, { package: props.package, packageElementTitle: props.packageElementTitle }));
        case 'Inventory::Product':
            return (_jsx(Products, { package: props.package, packageElementTitle: props.packageElementTitle }));
        case 'AppointmentType':
            return (_jsx(AppointmentTypes, { package: props.package, packageElementTitle: props.packageElementTitle }));
        case 'OrderEntity':
            return (_jsx(OrderEntities, { package: props.package, packageElementTitle: props.packageElementTitle }));
        default:
            return null;
    }
};
export default localeTranslator(PackageDetails, 'newPackage');
